import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import IdsData from "./ids_data/IdsData";
import CampaignGroups from "../CampaignGroups";
import Goals from "./goals/Goals";
import Dashboard from "./dashboard/Dashboard";
import Alerts from "./alerts/Alerts";
import updateParams from "utils/updateParams.js";
import jsDig from "utils/jsDig"

export default function Social(props) {
	const [tabLocation, setTabLocation] = useState("");

	useEffect(() => {
		let searchParams = new URL(location.href).searchParams;
		let page = searchParams.get("subpage");
		if (!page || page == "") {
			page = "ids_data";
		}
		setTabLocation(page);
		updateParams("subpage", page);
	}, []);

	const selectTab = (key) => {
		setTabLocation(key);
		updateParams("subpage", key);
	};

	// Will come from controller eventually
	const campaignGroups = props.social_section.campaign_groups

	return (
		<>
			<div className="px-md-5 px-0 pb-5 pt-0 ppc-config-social">
				{props.selectedPage == "social" && (
					<input hidden name="selected_subpage" value={tabLocation} readOnly />
				)}
				<Tab.Container
					id="ppc-social-subtabs"
					defaultActiveKey="ids_data"
					activeKey={tabLocation}
					onSelect={(k) => selectTab(k)}
				>
					<Nav
						variant="pills"
						className="mt-4 pb-0 nav-fill tabs-navigation-3 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-5"
					>
						<Nav.Item className="col">
							<Nav.Link eventKey="ids_data" data-link-type="subpage">IDs and Data</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="campaign_groups" data-link-type="subpage">Campaign Groups</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="goals" data-link-type="subpage">Goals</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="dashboard" data-link-type="subpage">Dashboard</Nav.Link>
						</Nav.Item>
						<Nav.Item className="col">
							<Nav.Link eventKey="alerts" data-link-type="subpage">Alerts</Nav.Link>
						</Nav.Item>
					</Nav>
					<Tab.Content className="pl-md-0">
						<Tab.Pane eventKey="ids_data">
							<IdsData {...props} />
						</Tab.Pane>
						<Tab.Pane eventKey="campaign_groups">
							<CampaignGroups {...props} platformType="Social" campaignGroups={campaignGroups}/>
						</Tab.Pane>
						<Tab.Pane eventKey="goals">
							<Goals {...props} campaignGroups={campaignGroups}/>
						</Tab.Pane>
						<Tab.Pane eventKey="dashboard">
							<Dashboard {...props} />
						</Tab.Pane>
						<Tab.Pane eventKey="alerts">
							<Alerts {...props} />
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			</div>
		</>
	);
}
